import SchemaMarkup from "../Components/SchemaMarkup";

const PrakrutiAnalysisSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",

        "@id": "https://msayurved.com/prakruti-analysis/#webpage",

        "url": "https://msayurved.com/prakruti-analysis/",

        "name": "Prakruti Analysis | Ayurveda Body Type Analysis",

        "description":
          "Take the Prakruti Analysis assessment to understand your Ayurvedic body constitution based on Vata, Pitta, and Kapha.",

        "isPartOf": {
          "@id": "https://msayurved.com/#website"
        },

        "about": {
          "@id": "https://msayurved.com/prakruti-analysis/#application"
        },

        "mainEntity": {
          "@id": "https://msayurved.com/prakruti-analysis/#application"
        },

        "inLanguage": "en-IN"
      },

      {
        "@type": "WebApplication",

        "@id": "https://msayurved.com/prakruti-analysis/#application",

        "name": "Prakruti Analysis",

        "url": "https://msayurved.com/prakruti-analysis/",

        "description":
          "An online Ayurvedic Prakruti Analysis assessment designed to help users understand their Vata, Pitta, and Kapha constitution.",

        "applicationCategory": "HealthApplication",

        "operatingSystem": "All",

        "browserRequirements": "Requires JavaScript",

        "provider": {
          "@id": "https://msayurved.com/#organization"
        },

        "creator": {
          "@id": "https://msayurved.com/#person"
        },

        "inLanguage": "en-IN"
      }
    ]
  };

  return <SchemaMarkup data={schema} />;
};

export default PrakrutiAnalysisSchema;